import Event from "./Event.mjs";
import TextLabel from "../../../Controls/TextLabel.mjs";
import appLib from "../../../libs/appLib.mjs";

//const G = window.glob;

const EventMail = class extends Event {
	constructor(props) {
		super(props);
		this.state.msg = this.props.options.game.im[this.props.event.data.ref];
	}
	isInjection() {
		return (!! this.state.msg?.injection );
	}
	additionalClassName() { return "comm im"; }
	description() {
		const e = this.props.event;
		const group = e.data.group;
		const from = appLib.player2name( e.data.from, e.data.player);
		const to = group ?
			appLib.group2name(group) :
			(e.data?.to||[]).map(r => appLib.player2name(r)).join(', ');
		return(
			<>
				<span className={"Desc"} title={from}>
					<TextLabel value={"From"}/>: {from}
				</span>
				<span className={"Desc"} title={to}>
					<TextLabel value={group ? "Group" : "To"} />: {to}
				</span>
			</>
		);
	}

	details() {
		const m = this.state.msg;
		if ( ! m ) return '';
		return(<>
			<h4 key={"Subject"}>
				{ m.subject }
			</h4>
			<div key={"Body"}>
				{
					m.html ?
						<div className={"Html"} dangerouslySetInnerHTML={{__html: m.body }} />
						:
						<div className={"Text"}>{ m.body }</div>
				}
			</div>
		</>);
	}
}

export default EventMail;